import { Component, ViewEncapsulation } from "@angular/core";
import { MCBarSkeletonComponent } from "@maslul/common-components";

@Component({
    selector: 'mi-genral-skeleton',
    templateUrl: './general-skeleton.html',
    styleUrls: ['./general-skeleton.scss'],
    imports: [
        MCBarSkeletonComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class GeneralSkeletonComponent {


}
